import { FC, ReactElement, useState } from 'react'
import ReactPlayer from 'react-player'
import styled, { keyframes } from 'styled-components'
import { device } from '../breakpoints'
import { BsFillMicMuteFill } from 'react-icons/bs'

const isMobile = window.innerWidth < 768

type VideoAutoProps = {
  src: string
  muted: boolean
}

const VideoAuto: FC<VideoAutoProps> = ({ src, muted }): ReactElement => {
  const [isMuted, setIsMuted] = useState(muted)

  const handleMuteIconClick = () => {
    setIsMuted(!isMuted)
  }

  // useEffect(() => {
  //   if (isMobile) {
  //     setMuted(true)
  //   }
  // }, [src])

  return (
    <Container>
      <ReactPlayer
        width={isMobile ? '100%' : 360}
        height='auto'
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload noplaybackrate pictureinpicture',
            },
          },
        }}
        playsinline
        playing
        loop
        controls
        muted={isMuted}
        url={src}
      />

      {isMuted && (
        <SoundIcon onClick={handleMuteIconClick}>
          {isMuted ? (
            <BsFillMicMuteFill />
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='28'
              viewBox='0 0 24 24'
            >
              <path
                stroke='white'
                d='M6,7l8-5v20l-8-5V7z M0,17h4V7H0V17z M20.3,3.7l-1.5,1.5c1.8,1.8,3,4.2,3,6.8s-1.1,5-3,6.8l1.5,1.5c2.3-2.2,3.7-5.1,3.7-8.3
	S22.6,5.9,20.3,3.7z M19.8,12c0-2.1-0.9-4-2.4-5.4l-1.5,1.5c1,1,1.6,2.4,1.6,3.9c0,1.5-0.6,2.8-1.6,3.9l1.5,1.5
	C18.9,16,19.8,14.1,19.8,12z'
              />
            </svg>
          )}
          <SoundIconLabel>
            <SoundIconLabelContent>
              {isMuted ? 'Réactiver' : 'Couper'} le son
            </SoundIconLabelContent>
          </SoundIconLabel>
        </SoundIcon>
      )}
    </Container>
  )
}

const FadeOutAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

const ShrinkAnimation = keyframes`
  0% {
    max-width: 100px;
  }
  100% {
    max-width: 0px;
  }
`

const Container = styled.div`
  display: block;
  width: 100%;

  position: relative;
  display: flex;
  justify-content: center;
  background-color: #000000;
  color: white;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
  }

  @media ${device.tablet}, @media ${device.laptop} {
  }
`
const SoundIcon = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  background-color: #6f7187;
  padding: 0.5em;
  font-size: 0.85em;
  font-family: var(--font-sans-serif);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  animation: ${FadeOutAnimation} 300ms ease-out forwards;
  animation-delay: 8000ms;
`
const SoundIconLabel = styled.div`
  display: inline-block;
  animation: ${ShrinkAnimation} 300ms ease-out forwards;
  animation-delay: 8000ms;
  overflow: hidden;
  margin-left: 0.65em;
`
const SoundIconLabelContent = styled.div`
  display: block;
  width: 150px;
`

export default VideoAuto
